import React, { useState } from 'react'
import { ModalButton } from 'src/components/Global/Button/Button'
// import { PinInput } from 'src/components/Global/Input'
import { addNairaSign } from 'src/utils/addNairaSign'
import { useDispatch } from 'react-redux'
import { WithdrawalAction } from '../../../../../redux/actions/withdrawal'
import PinInput from 'react-pin-input'
import useSnackbar from 'src/hooks/useSnackBar'
import { Link, useLocation } from 'react-router-dom'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import {
  CheckoutModalBackground,
  CheckoutModalContainer,
  CheckoutWrapper,
  CloseCheckoutModalBtn,
} from './style'
import useUserData from 'src/hooks/useUserData'

const CheckoutPage = ({
  showCheckoutPage,
  setShowCheckoutPage,
  bank,
  amount,
  fullWithdrawal,
  sourceId,
  balance,
}: // userBanks,
any) => {
  const snackbar = useSnackbar()
  console.log(bank)
  const closeModal = () => {
    setShowCheckoutPage(false)
  }
  const USER_DATA = useUserData()
  let location = useLocation()
  const dispatch = useDispatch()

  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState(false)

  console.log(pin)

  const payload = {
    source: 'plan',
    source_id: sourceId,
    full_withdrawal: fullWithdrawal,
    bank_id: bank.id,
    pin: pin,
    amount: amount,
  }

  const amount_to_pay = balance.replace(/,/g, '')
  console.log(amount, balance.replace(/,/g, ''), 'confirm')

  const initiateWithdrawal = () => {
    setLoading(true)
    let payload
    if (amount === amount_to_pay) {
      payload = {
        source: 'plan',
        source_id: sourceId,
        full_withdrawal: amount === amount_to_pay ? true : false,
        bank_id: bank.id,
        pin: pin,
      }
    } else {
      payload = {
        source: 'plan',
        source_id: sourceId,
        full_withdrawal: amount === amount_to_pay ? true : false,
        bank_id: bank.id,
        pin: pin,
        amount: amount,
      }
    }
    setLoading(true)
    dispatch(WithdrawalAction({ payload, onSuccess, onError }))
  }
  const onSuccess = (msg: string) => {
    setLoading(false)
    console.log(msg)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: string) => {
    setLoading(false)
    console.log(error)
    snackbar.trigger({
      message: error,
      severity: 'error',
    })
  }
  return (
    <CheckoutModalContainer>
      {showCheckoutPage ? (
        <CheckoutModalBackground>
          <CloseCheckoutModalBtn onClick={closeModal} />
          <CheckoutWrapper>
            <div>
              <div className="header">
                <h3>Almost done</h3>
                <p>Here is a quick review of your withdrawal</p>
              </div>

              <div className="checkout_details_flex">
                <div className="flex_one">
                  <h3>Recipient Name:</h3>
                  <p>{bank.account_name}</p>
                </div>
                <div className="flex_one">
                  <h3>Bank Account:</h3>
                  <p>{bank.account_number}</p>
                </div>
                <div className="flex_one">
                  <h3>Bank Name:</h3>
                  <p>{bank.bank_name}</p>
                </div>
                <div className="flex_one">
                  <h3>Amount to withdraw:</h3>
                  <p>{addNairaSign(amount)}</p>
                </div>
              </div>
            </div>
            {!USER_DATA.user.has_withdrawal_pin && (
              <Link to={'/create-pin'} state={{ backgroundLocation: location }}>
                <div className="create">Create pin now</div>
              </Link>
            )}
            {USER_DATA.user.has_withdrawal_pin && (
              <div className="pin_wrapper">
                <p>Enter your pin</p>
                <PinInput
                  length={6}
                  initialValue=""
                  secret
                  type="numeric"
                  onChange={(value, index) => {
                    setPin(value)
                  }}
                  inputMode="number"
                  style={{ paddingRight: '12px' }}
                  inputStyle={{ borderColor: '#6E7191', marginRight: '12px' }}
                  inputFocusStyle={{ borderColor: '#0519ff' }}
                  autoSelect={true}
                  regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />
              </div>
            )}

            <div className="authorize_btn_wrapper">
              <ModalButton onClick={initiateWithdrawal}>
                Authorize {loading && <Spinner />}
              </ModalButton>
            </div>
          </CheckoutWrapper>
        </CheckoutModalBackground>
      ) : null}
    </CheckoutModalContainer>
  )
}

export default CheckoutPage
